<template>
  <div id="contenedor-obras-default">
    <v-container fluid>
      <v-card
        class="mb-4" flat>
        <v-card-text>
          <titulo-tool-bar titulo="Planeación">
            <template v-slot:opciones-derecha>
              <template v-if="$vuetify.breakpoint.xs">
              <v-menu
                v-if="mixValidaScopesActions(1)"
                :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                  @click="mostrarVentanaExcelContratos = !mostrarVentanaExcelContratos">
                    <v-list-item-icon class="mx-0 px-2">
                      <v-icon> mdi-file-excel </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Exportar Contratos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                  :to="{ name: 'planeacionConfiguracionFirmas' }">
                    <v-list-item-icon class="mx-0 px-2">
                      <v-icon> mdi-cog-outline </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Configuración Planeación</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              </template>
              <template v-else>
                <v-tooltip
                v-if="mixValidaScopesActions(1)"
                top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="mostrarExportarObras = !mostrarExportarObras">
                    <v-icon> mdi-file-excel </v-icon>
                  </v-btn>
                </template>
                <span> Exportar Obras</span>
                </v-tooltip>
                <v-tooltip
                v-if="mixValidaScopesActions(1)"
                top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :to="{ name: 'planeacionConfiguracionFirmas' }"
                    icon
                    v-bind="attrs"
                    v-on="on">
                    <v-icon> mdi-cog-outline </v-icon>
                  </v-btn>
                </template>
                <span> Configuración Planeación</span>
                </v-tooltip>
              </template>
            </template>
          </titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :listaObras="getObras"
            :filtros="filtros"
            v-on:nuevaObra="registrarNuevaObra"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-else
            :listadoObras="getListadoObras">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaObra"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <registrar-nueva-obra
        v-if="mostrarVentanaRegistrarNuevaObra"
        :filtros="filtros"
        v-on:cerrar="cerrarRegistrarNuevaObra">
      </registrar-nueva-obra>
    </v-dialog>
    <v-dialog
      v-if="estaObra"
      v-model="mostrarVentanaEditarObra"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <editar-obra
        :obraEditar="estaObra"
        :filtros="filtros"
        v-on:cerrar="cerrarEditarObra">
      </editar-obra>
    </v-dialog>
    <v-dialog
      v-if="estaObra"
      v-model="mostrarVentanaEliminarObra"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-obra
        :obraEliminar="estaObra"
        :filtros="filtros"
        v-on:cerrar="cerrarRemoverObra">
      </eliminar-obra>
    </v-dialog>
    <v-dialog
      v-if="mostrarExportarObras"
      v-model="mostrarExportarObras"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <exportar-obras-excel
        :obras="getObras"
        :filtros="this.filtros"
        v-on:cerrar="mostrarExportarObras = !mostrarExportarObras">
      </exportar-obras-excel>
    </v-dialog>
    <v-dialog
      v-if="estaObra"
      v-model="mostrarRegistrarProyecto"
      :width="$vuetify.breakpoint.mobile ? '100%' : '40%'"
      scrollable
      permanent>
      <v-card>
        <v-card-title>
          Registrar proyecto
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarRegistrarProyecto">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <RegistrarProyecto
            ref="registrarProyecto"
            :id-obra="estaObra.id"
            :filtros="filtros"
            v-on:cerrar="cerrarRegistrarProyecto">
          </RegistrarProyecto>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarRegistrarProyecto"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="$refs.registrarProyecto.guardar()"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="mostrarVentanaGenerarNuevaPlantilla"
      scrollable
      persistent
      width="800"
    >
      <generar-nueva-plantilla
        modulo="planeacion"
        :datos="getDatos"
        :idarchivo="getNombreArchivo"
        ref="generarNuevaPlantilla"
        @cerrarGenerarNuevaPlantilla="cerrarGenerarNuevaPlantilla"
      >
      </generar-nueva-plantilla>
    </v-dialog>
  </div>
</template>

<script>
import OBRAS from '@/graphql/querys/administracion/planeacion/buscarObras.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import RegistrarNuevaObra from '@/components/administracion/obras/Nuevo.vue';
import EditarObra from '@/components/administracion/obras/Editar.vue';
import EliminarObra from '@/components/administracion/obras/Eliminar.vue';
import ExportarObrasExcel from '@/components/exportar/exceles/ExcelObras.vue';
import RegistrarProyecto from '@/components/administracion/control-proyectos/NuevoProyecto.vue';
import GenerarNuevaPlantilla from '@/components/administracion/configuracion/plantillas/generador/Default.vue';
import MixDatosPlaneacion from '@/components/administracion/configuracion/plantillas/generador/mixDatosPlaneacion';
import eventBus from '@/helpers/eventBus';
import CustomButton from '@/components/buttons/Button.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

const hoy = new Date();

export default {
  name: 'PlaneacionDefault',
  mixins: [MixDatosPlaneacion],
  components: {
    TituloToolBar,
    RegistrarNuevaObra,
    EditarObra,
    EliminarObra,
    ExportarObrasExcel,
    RegistrarProyecto,
    GenerarNuevaPlantilla,
    CustomButton,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarRegistrarProyecto: false,
      mostrarVentanaRegistrarNuevaObra: false,
      mostrarVentanaEditarObra: false,
      mostrarVentanaEliminarObra: false,
      mostrarVentanaGenerarNuevaPlantilla: false,
      mostrarExportarObras: false,
      estaObra: null,
      filtros: {
        ejercicio: hoy.getFullYear(),
        buscar: '',
        idTipo: null,
        idPrograma: null,
        incluirConContratos: false,
        etiquetas: [],
        numeroRegistros: 100,
        pagina: 1,
      },
    };
  },
  apollo: {
    buscarObras: {
      query: OBRAS,
      variables() {
        return {
          filtros: {
            ejercicio: this.filtros.ejercicio,
            buscar: this.filtros.buscar,
            idTipo: this.filtros.idTipo,
            idPrograma: this.filtros.idPrograma,
            etiquetas: this.filtros.etiquetas,
            incluirConContratos: this.filtros.incluirConContratos,
            numeroRegistros: this.filtros.numeroRegistros,
            pagina: this.filtros.pagina,
          },
        };
      },
    },
  },
  methods: {
    registrarNuevaObra() {
      this.mostrarVentanaRegistrarNuevaObra = true;
    },
    cerrarRegistrarNuevaObra() {
      this.mostrarVentanaRegistrarNuevaObra = false;
    },
    cerrarEditarObra() {
      this.mostrarVentanaEditarObra = false;
      this.estaObra = null;
    },
    cerrarRemoverObra() {
      this.mostrarVentanaEliminarObra = false;
      this.estaObra = null;
    },
    cerrarRegistrarProyecto() {
      this.$refs.registrarProyecto.cancelar();
      this.mostrarRegistrarProyecto = false;
      this.estaObra = null;
    },
    generarNuevaPlantilla() {
      this.mostrarVentanaGenerarNuevaPlantilla = !this.mostrarVentanaGenerarNuevaPlantilla;
    },
    cerrarGenerarNuevaPlantilla() {
      this.generarNuevaPlantilla();
    },
  },
  computed: {
    getObras() {
      if (!this.buscarObras) return [];
      return this.buscarObras.obras;
    },
    getListadoObras() {
      if (!this.buscarObras) return [];
      return this.buscarObras.obras;
    },
    getDatos() {
      if (!this.estaObra) return {};
      return this.formatoWordPlaneacion(this.estaObra);
    },
    getNombreArchivo() {
      if (!this.estaObra) return 'sinClave';
      return this.estaObra.clave;
    },
  },
  mounted() {
    eventBus.$on('registrar-proyecto', (obra) => {
      this.estaObra = obra;
      this.mostrarRegistrarProyecto = true;
    });
    eventBus.$on('editar-obra', (obra) => {
      this.estaObra = obra;
      this.mostrarVentanaEditarObra = true;
    });
    eventBus.$on('eliminar-obra', (obra) => {
      this.estaObra = obra;
      this.mostrarVentanaEliminarObra = true;
    });
    eventBus.$on('generar-plantillas', (obra) => {
      this.estaObra = obra;
      this.mostrarVentanaGenerarNuevaPlantilla = true;
    });
  },
};
</script>

<style lang="scss">

</style>
